import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Button, Text } from '@qm/ui';
import { useApp } from '../../../lib/app-context';
import '../setup/setup.css';
export interface Enrollment {
  factorId: string;
  secret: string;
  otpauthUri: string;
}
export function SecurityChoice({
  passkeyAvailable,
  onAuthenticator,
  onPasskey,
  busy,
}: {
  passkeyAvailable: boolean;
  onAuthenticator: () => void;
  onPasskey: () => void;
  busy: boolean;
}) {
  const { locale } = useApp(),
    ar = locale === 'ar';
  return (
    <div className="qm-setup__choices" data-testid="security-choice">
      <Text>
        {ar
          ? 'اختر طريقة واحدة لحماية حسابك. يمكنك إضافة الأخرى لاحقاً.'
          : 'Choose one way to secure your account. You can add the other later.'}
      </Text>
      <Button
        type="button"
        onClick={onAuthenticator}
        disabled={busy}
        data-testid="authenticator-choice"
      >
        {ar ? 'استخدام تطبيق المصادقة' : 'Use an authenticator'}
      </Button>
      <Text tone="muted">
        {ar
          ? 'امسح رمز QR وأكّد رمزاً من 6 أرقام.'
          : 'Scan a QR code, then confirm the 6-digit code from your app.'}
      </Text>
      {passkeyAvailable ? (
        <>
          <Button type="button" onClick={onPasskey} disabled={busy} data-testid="passkey-enrol">
            {ar ? 'إنشاء مفتاح مرور' : 'Create a passkey'}
          </Button>
          <Text tone="muted">
            {ar
              ? 'استخدم بصمة الإصبع أو الوجه أو رمز جهازك.'
              : 'Use your fingerprint, face or device PIN.'}
          </Text>
        </>
      ) : null}
    </div>
  );
}
export function AuthenticatorSetup({ factor }: { factor: Enrollment }) {
  const { locale } = useApp(),
    ar = locale === 'ar';
  const [show, setShow] = useState(false),
    [copied, setCopied] = useState(false),
    [copyFailed, setCopyFailed] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(factor.secret);
      setCopied(true);
      setCopyFailed(false);
    } catch {
      setCopyFailed(true);
    }
  };
  return (
    <div className="qm-setup__authenticator">
      <Text>
        {ar
          ? 'افتح تطبيق المصادقة وامسح الرمز.'
          : 'Open your authenticator app and scan this code.'}
      </Text>
      <div className="qm-setup__qr" data-testid="authenticator-qr">
        <QRCodeSVG
          value={factor.otpauthUri}
          size={208}
          marginSize={4}
          title={ar ? 'رمز إعداد تطبيق المصادقة' : 'Authenticator setup QR code'}
        />
      </div>
      <Button
        type="button"
        aria-expanded={show}
        aria-controls="manual-setup-key"
        onClick={() => {
          setShow(!show);
          setCopied(false);
        }}
      >
        {show
          ? ar
            ? 'إخفاء مفتاح الإعداد'
            : 'Hide setup key'
          : ar
            ? 'تعذّر المسح؟ أظهر مفتاح الإعداد'
            : 'Can’t scan? Show setup key'}
      </Button>
      {show ? (
        <div id="manual-setup-key" className="qm-setup__key">
          <code dir="ltr" tabIndex={0}>
            {factor.secret}
          </code>
          <Button type="button" onClick={() => void copy()}>
            {ar ? 'نسخ المفتاح' : 'Copy key'}
          </Button>
          <span role="status">
            {copied
              ? ar
                ? 'تم النسخ'
                : 'Copied'
              : copyFailed
                ? ar
                  ? 'حدّد المفتاح وانسخه يدوياً.'
                  : 'Select the key and copy it manually.'
                : ''}
          </span>
        </div>
      ) : null}
      <Text tone="muted">
        {ar ? 'هذا المفتاح سري. لا تشاركه.' : 'This key is secret. Do not share it.'}
      </Text>
    </div>
  );
}
